
export function createSubmitData(requestId, formData) {

    let submitData = {
        id: parseInt(requestId),
        truck: parseInt(formData['truck']),
        notes: formData['notes'],
        items: []
    }

    formData.equipment.forEach(item => {

        const itemData = {
            id: parseInt(item.id),
            sentQuantity: parseInt(item.sentQuantity),
            note: item.note
        }

        submitData.items.push(itemData)
    })

    return submitData
}

export function formatPrefillData(equipment) {

    return equipment.filter(item => {
        return item['sentQuantity'] == null
    })
    .map(item => {

        return {
            ...item,
            sentQuantity: parseInt(item.requestedQuantity),
            maxQuantity: parseInt(item.equipment.quantity)
        }
    })
}